import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=33212fcc&scoped=true"
import script from "./countDown.vue?vue&type=script&lang=js"
export * from "./countDown.vue?vue&type=script&lang=js"
import style0 from "./countDown.vue?vue&type=style&index=0&id=33212fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33212fcc",
  null
  
)

export default component.exports